import moment from "moment";
import "moment/locale/fr";
import { capitalizeFirstLetter } from "../../Utils/Function";

/** « 1 732,50 € » */
export const euros = (value: number | string | null | undefined, digits = 2): string => {
    const n = typeof value === "string" ? parseFloat(value) : (value ?? 0);
    const safe = isNaN(n as number) ? 0 : (n as number);
    return `${safe.toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits })} €`;
};

/** Heures décimales → « 1 h 30 », « 2 h », « 45 min ». */
export const hours = (value: number | null | undefined): string => {
    const total = Math.round((value ?? 0) * 60);
    const h = Math.floor(total / 60);
    const m = total % 60;
    if (h === 0) return m === 0 ? "0 h" : `${m} min`;
    return m === 0 ? `${h} h` : `${h} h ${String(m).padStart(2, "0")}`;
};

/** Demi-heures de l'API (durée des cours) → « 14 h 30 ». */
export const hoursFromHalfHours = (halfHours: number | null | undefined): string => hours((halfHours ?? 0) / 2);

/** « 16h00 » */
export const clock = (value: moment.MomentInput): string => moment(value).format("HH[h]mm");

/** « Jeudi 15 octobre » */
export const dayLabel = (value: moment.MomentInput, withYear = false): string =>
    capitalizeFirstLetter(moment(value).locale("fr").format(withYear ? "dddd D MMMM YYYY" : "dddd D MMMM"));

/** « Octobre 2026 » */
export const monthLabel = (value: moment.MomentInput): string =>
    capitalizeFirstLetter(moment(value).locale("fr").format("MMMM YYYY"));

/** « octobre » */
export const monthName = (value: moment.MomentInput): string => moment(value).locale("fr").format("MMMM");

/** Prénom affiché avec une majuscule, nom complet « Prénom Nom ». */
export const studentFirstName = (child: any): string => capitalizeFirstLetter(child?.childFirstName ?? "");
export const studentFullName = (child: any): string =>
    `${studentFirstName(child)} ${capitalizeFirstLetter((child?.childLastName ?? "").toLowerCase())}`.trim();

/** Initiales pour l'avatar : « BA ». */
export const initials = (child: any): string =>
    `${(child?.childFirstName ?? "").charAt(0)}${(child?.childLastName ?? "").charAt(0)}`.toUpperCase();

/** Pluriel simple : plural(3, "séance") → « 3 séances ». */
export const plural = (count: number, word: string, pluralWord?: string): string =>
    `${count} ${count > 1 ? (pluralWord ?? `${word}s`) : word}`;

/** Majuscule initiale, sans planter sur une valeur vide. */
export const capitalizeFirstLetterSafe = (value: string | null | undefined): string =>
    value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
